export default __webpack_public_path__ + "static/media/topExplorerBackground.88f28923.jpg";